import { NSARouterMakerResult } from "namirasoft-account-react";
import { EnvService } from "namirasoft-core";
import GithubLoginButton from "./GithubLoginButton";

import Style from "./AccountGithubLogin.module.css";

interface AccountGithubLoginProps extends NSARouterMakerResult { }

export function AccountGithubLogin(props: AccountGithubLoginProps)
{
    let REACT_APP_GITHUB_CLIENT_ID = new EnvService("REACT_APP_GITHUB_CLIENT_ID", true).getString();

    return (
        <div className={Style.ns_account_github_login}>
            <GithubLoginButton {...props} clientId={REACT_APP_GITHUB_CLIENT_ID} />
        </div>
    );
}